// import React, { useContext } from "react";
// //icons
// import { IoClose } from "react-icons/io5";
// //Context
// import { CartContext } from "../context/CartContext";
// //compoents
// import CartItem from "../components/CartItem";
// const Cart = () => {
//   const { setIsOpen, cart } = useContext(CartContext);
//   return (
//     <div className="w-full h-full px-4 text-white">
//       <div
//         onClick={() => setIsOpen(false)}
//         className="text-4xl w-20 h-[98px] flex justify-start items-center"
//       >
//         {/* close icon */}
//         <IoClose />
//       </div>
//       <div>
//         {cart.map((item) => {
//           return <CartItem item={item} key={item.id} />;
//         })}
//       </div>
//     </div>
//   );
// };

// export default Cart;





import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
//Context
import { CartContext } from "../context/CartContext";
//compoents
import CartItem from "../components/CartItem";
const Cart = () => {
  const { setIsOpen, cart } = useContext(CartContext);
  const navigate = useNavigate();
  const handleCheckoutClick = () => {
    setIsOpen(false); // Close cart if it's a side panel
    navigate("/checkoutform"); // ✅ Navigate to checkout route
  };

   const subtotal = cart.reduce((total, item) => {
    return total + item.price * item.amount;
  }, 0);

  const deliveryCharge = 4;
  const grandTotal = subtotal + deliveryCharge;
  return (
    <div className="w-full h-full px-4 text-white">
      <div
        onClick={() => setIsOpen(false)}
        className="text-4xl w-20 h-[98px] flex justify-start items-center"
      >
        {/* close icon */}
        <IoClose />
      </div>

      <div>
        {cart.length === 0 ? (
          <div className="text-center text-gray-300 mt-10 text-lg font-semibold">
            Your cart is empty.
          </div>
        ) : (
          <>
            {cart.map((item) => (
              <CartItem item={item} key={item.id} />
            ))}

             <div className="bg-gray-800 p-4 mt-6 rounded-lg shadow-md text-sm text-gray-200">
              <div className="flex justify-between mb-2">
                <span>Subtotal</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex justify-between mb-2">
                <span>Delivery Charges</span>
                <span>${deliveryCharge.toFixed(2)}</span>
              </div>
              <div className="border-t border-gray-600 my-2"></div>
              <div className="flex justify-between font-bold text-lg">
                <span>Grand Total</span>
                <span>${grandTotal.toFixed(2)}</span>
              </div>
            </div>
            <div>
              <button
                onClick={handleCheckoutClick}
                className="mt-4 bg-[#f24a04] hover:bg-green-600 text-white py-2 px-6 rounded-lg transition duration-200 w-max"
              >
                Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
